<common-navigation></common-navigation>

<div class="default-box d-flex align-items-center mx-auto col-md-5 col-lg-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-xl-12 mb-100">
                <div id="page-redirection">
                    <a routerLink="/sign-in">
                        <img src="../../../../assets/images/arrows/back_arrow.png">
                        Go back
                    </a>
                </div>

                <h3 class="display-4 box-title mt-5">Delete your account</h3> <br>
                <p>Click the button below to delete your account.</p>

                <div class="alert alert-warning alert-dismissible fade show" role="alert" *ngIf="error">
                    <button type="button" class="close" data-dismiss="alert">&times;</button>
                    {{ errorMsg }}
                </div>
                <div class="alert alert-success alert-dismissible fade show" role="success" *ngIf="success">
                    <button type="button" class="close" data-dismiss="alert">&times;</button>
                    Account successfully deleted.
                </div>
                <form [formGroup]="deleteForm">
                    <div class="md-input">
                        <input class="md-form-control"
                            required
                            type="text"
                            formControlName="email"
                            [ngClass]="{'error': (submitted && deleteForm.invalid && f.email.invalid) || (f.email.dirty && f.email.invalid)}"
                            [disabled]="loading"
                        >
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label>Email</label>
                    </div>
                    <div class="md-input">
                        <input
                            class="md-form-control"
                            required
                            type="password"
                            formControlName="password"
                            id="password-input"
                            [ngClass]="{'error': (submitted && deleteForm.invalid && f.password.invalid) || (f.password.dirty && f.password.invalid)}"
                            [disabled]="loading"
                        >
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label>Password</label>
                    </div>
                    <button (click)="showModal()" class="btn btn-primary btn-block btn-submit" [disabled]="loading">Delete My Account
                        <img src="../../../../assets/images/loader.gif" *ngIf="loading">
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" #modal id="confirmModalCenter" tabindex="-1" role="dialog" aria-labelledby="confirmModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title" id="cancelModalTitle">Confirm Delete</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            </div>
            <div class="modal-body py-4">
                Are you sure you would like to delete this account? This action cannot be undone. Any active subscriptions will be automatically cancelled.
            </div>
            <div class="modal-footer">
                <button type="button" class="pull-right btn btn-secondary btn-sm" data-dismiss="modal">Close</button>
                <button (click)="onConfirm()" class="pull-right btn btn-danger btn-sm">Confirm</button>
            </div>
        </div>
    </div>
</div>